import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ErrorInterceptorService } from '../../services/error-interceptor.service';
import { Observable } from 'rxjs';
import { NewLine } from '../../pipes/new-line.pipe';

@Component({
  selector: 'app-error-interceptor',
  templateUrl: './error-interceptor.component.html',
  styleUrls: ['./error-interceptor.component.scss'],
  standalone: true,
  imports: [CommonModule, NewLine]
})
export class ErrorInterceptorComponent implements OnInit {
  public error$: Observable<any>;
  public isShow = false;
  public hideInterval = 5000;
  public errorMessage: string;
  constructor(private errorInterceptorService: ErrorInterceptorService) {}
  ngOnInit() {
    this.error$ = this.errorInterceptorService.asObservable();
    this.error$.subscribe(error => {
      if (error.message) {
        this.isShow = true;
        this.errorMessage = error.message;
      } else if (error) {
        this.isShow = true;
        this.errorMessage =
          'エラーが発生しました。通信環境をご確認ください。エラーが解消されない場合、お問い合わせください';
      }
      setTimeout(() => {
        this.isShow = false;
        this.errorMessage = '';
      }, this.hideInterval);
    });
  }
}
